<template>
  <v-dialog v-model="dialog" width="800px">
    <v-card class="bg-white">
      <v-card-title class="bg-00A99D py-8" style="border-bottom-left-radius: 0; border-bottom-right-radius: 0">
        <v-row justify="center">
          <span v-if="type == 'edit'" class="text-white font-32 w-700 pl-5">ระบุแผนที่</span>
          <span v-else-if="type == 'view'" class="text-white font-32 w-700 pl-5">แผนที่</span>
          <v-spacer></v-spacer>
          <v-btn icon @click="
            closeDialog()"
            small color="#FFFFFF"
            class="mr-3"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-row>
      </v-card-title>
      <v-card-text class="py-8">
        <v-row v-if="type == 'edit'" class="pb-3">
          <v-col cols="4" class="py-0" align-self="end">
            <v-btn depressed color="#F7F8FA" @click="checkGPS()">
              <v-icon size="20" class="pr-1" color="#00A99D">mdi-crosshairs-gps</v-icon><span
                class="text-7E8386 w-400 font-14">คลิกเพื่อหาที่อยู่ปัจจุบันของคุณ</span>
            </v-btn>
          </v-col>
        </v-row>
        <v-row v-if="type == 'edit'" class="pb-3">
          <v-col cols="12" class="py-0">
            <GmapAutocomplete @place_changed="setPlace" class="pl-2 gmap-auto" :value="search"
              :options="{ fields: ['geometry', 'formatted_address', 'address_components'] }" />
          </v-col>
        </v-row>
        <v-row class="pb-3">
          <v-col cols="12" class="py-0">
            <GmapMap :center="{ lat: latitude, lng: longitude }" :zoom="15" class="map" :options="{
              zoomControl: true,
              mapTypeControl: false,
              scaleControl: false,
              streetViewControl: false,
              rotateControl: true,
              fullscreenControl: true,
              disableDefaultUi: true,
            }">
              <GmapMarker v-if="type == 'edit'" @click="changeLocation" @dragend="changeLocation" :draggable="true" :position="{
                lat: default_lat,
                lng: default_lng,
              }" />
              <GmapMarker v-else-if="type == 'view'" :position="{
                lat: default_lat,
                lng: default_lng,
              }" />
            </GmapMap>
          </v-col>
        </v-row>
        <v-row justify="center" align="center">
          <v-col cols="4" class="pt-4">
            <v-btn v-if="type == 'edit'" depressed block color="#00A99D" dark style="border-radius: 26px" @click="confirmMap()">
              <span class="font-16 w-500">ยืนยันตำแหน่ง</span>
            </v-btn>
            <v-btn v-else-if="type == 'view'" depressed block color="#00A99D" dark style="border-radius: 26px" @click="closeDialog()">
              <span class="font-16 w-500">ปิด</span>
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { gmapApi } from "vue2-google-maps";

export default {
  props: ["from"],
  data() {
    return {
      dialog: false,
      default_lat: 0,
      default_lng: 0,
      latitude: 0,
      longitude: 0,
      search: null,
      currentPlace: null,
      type: ''
    }
  },
  computed: {
    google: gmapApi,
  },
  methods: {
    openDialog (lat, lng, type) {
      this.default_lat = lat
      this.default_lng = lng
      this.getGPS();
      this.dialog = true;
      this.search = null
      this.currentPlace = null
      this.type = type
    },
    closeDialog() {
      this.default_lat = 0
      this.default_lng = 0
      this.type = ''
      this.dialog = false;
    },
    setPlace(place) {
      this.search = place.formatted_address;
      this.currentPlace = place;
      // console.log('this.currentPlace', this.currentPlace);
      this.latitude = this.currentPlace.geometry.location.lat()
      this.longitude = this.currentPlace.geometry.location.lng()
      this.default_lat = this.currentPlace.geometry.location.lat()
      this.default_lng = this.currentPlace.geometry.location.lng()
    },
    changeLocation(e) {
      this.default_lat = e.latLng.lat();
      this.default_lng = e.latLng.lng();
    },
    checkGPS() {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const { coords: { latitude: lat, longitude: lng } = {} } = position;
          this.latitude = lat;
          this.longitude = lng;
          this.default_lat = lat;
          this.default_lng = lng;
        },
        (error) => {
          console.log(error);
          this.snackbar = true;
        }
      );
    },
    getGPS() {
      this.latitude = parseFloat(this.default_lat || 0);
      this.longitude = parseFloat(this.default_lng || 0);
      this.default_lat = parseFloat(this.default_lat || 0);
      this.default_lng = parseFloat(this.default_lng || 0);
    },
    confirmMap() {
      var data = {
        lat: this.default_lat,
        lng: this.default_lng
      }
      this.$emit('submit',data)
      this.dialog = false
    },
  }
}
</script>

<style scoped>
.bg-white {
  background: white !important;
}
.gmap-auto {
  width: 100%;
  line-height: 35px;
  border: 1px solid #e8e9e9;
  border-radius: 5px;
  font-size: 14px;
}

.gmap-auto:focus {
  outline: none !important;
}
.map {
  border-radius: 15px !important;
  height: 30vh;
  width: 100%;
}
</style>